export const paymentTypes = [
  { label: "New Student", value: "New Student" },
  { label: "Renewal", value: "Renewal" },
  { label: "Referral", value: "Referral" },
  { label: "Additional Subject", value: "Additional Subject" },
  { label: "Validity Extension", value: "Validity Extension" },
];